import { NavLink } from "react-router-dom";
import * as React from 'react';
import { MenuItem } from "../Sidebar";
import Icon from "../../Icon";
import style from '../Sidebar.scss';
import classNames from "classnames";
import SidebarItem from "./SidebarItem";

type Props<S extends Record<string, any> = {}> = {
  title: string,
  items: MenuItem<S>[],
  context: S
};

const getActiveItems = <S, >(items: MenuItem<S>[], state: S) => {
  if (!Array.isArray(items) || !items.some(item => typeof item.isActive === 'function')) return items;

  const finalItems: MenuItem[] = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (typeof item.isActive === 'function' && !item.isActive(state)) continue;
    finalItems.push(item);
  }
  return finalItems;
}

const SidebarGroup: React.FunctionComponent<Props> = (props) => {
  const { title, items, context } = props;

  const renderItem = React.useCallback((menuItem: MenuItem, i: number) => {
    return <SidebarItem key={i} item={menuItem} context={context} />
  }, [context]);

  const activeItems = getActiveItems(items, context);

  if (!Array.isArray(activeItems) || !activeItems.length) return null;
  return (
    <>
      <div className={style.groupTitle}>
        <div className={style.groupTitleText}>{title}</div>
      </div>
      {activeItems.map(renderItem)}
    </>
  );
};

export default React.memo(SidebarGroup);
